import config from '../environmentConfig.json'
export default {
  AWSConfig: {
    Region: config[process.env.NODE_ENV].cognito.Region,
    IdentityPoolId: config[process.env.NODE_ENV].cognito.IdentityPoolId,
    UserPoolId: config[process.env.NODE_ENV].cognito.UserPoolId,
    ClientId: config[process.env.NODE_ENV].cognito.ClientId,
  },
}
